import { PayloadAction } from "@reduxjs/toolkit";
import { GetServicesListPayload } from "../../../services/service/payload/GetServicesList/GetServicesListPayload";
import { DashboardState } from "../../models/DashboardState";

const getActiveServicesListFetch = (state: DashboardState, action: PayloadAction<GetServicesListPayload>) => {
    state.isLoading = true;
}

export default getActiveServicesListFetch;